import { BaseApiService, apiClient } from 'shared/api/client';

export class StoreService extends BaseApiService {
    constructor() {
        super('/admin-api/stores');
    }

    getEmployees(storeId, queryString = '', token = 'token') {
        return apiClient.get(`${this.endpoint}/${storeId}/employees/`, queryString, token);
    }

    getConsultants(storeId, queryString = '', token = 'token') {
        return apiClient.get(`${this.endpoint}/${storeId}/consultants/`, queryString, token);
    }

    addEmployee(storeId, employeeId, token = 'token') {
        return apiClient.patch(`${this.endpoint}/${storeId}/employees/`, { id: employeeId }, token);
    }

    removeEmployee(storeId, employeeId, token = 'token') {
        return apiClient.delete(`${this.endpoint}/${storeId}/employees/`, { id: employeeId }, token);
    }

    updateEmployees(storeId, employees, token = 'token') {
        const data = employees.map(employee => ({ id: employee.id }));
        return apiClient.put(`${this.endpoint}/${storeId}/employees/`, data, token);
    }

    getCategoryStats(storeId, queryString = '', token = 'token') {
        queryString = `?store_id=${storeId}&` + queryString;
        return apiClient.get(`/stats/admin-api/snaps/by-categories/`, queryString, token);
    }

    getProductStats(storeId, queryString = '', token = 'token') {
        queryString = `?store_id=${storeId}&` + queryString;
        return apiClient.get(`/stats/admin-api/snaps/by-products/`, queryString, token);
    }
}

export class EmployeeService extends BaseApiService {
    constructor() {
        super('/admin-api/employees');
    }

    getNotifications(queryString = '', token = 'token') {
        return apiClient.get(`${this.endpoint}/notifications/`, queryString, token);
    }

    readAllNotifications(token = 'token') {
        return apiClient.put(`${this.endpoint}/notifications/`, {}, token);
    }


}

export class EmployeeGroupService extends BaseApiService {
    constructor() {
        super('/admin-api/employee-groups');
    }

    // Get sections for a specific employee group
    getSections(groupId, token = 'token') {
        return apiClient.get(`${this.endpoint}/${groupId}/sections/`, '', token);
    }

    // Update a section's inclusion status
    updateSection(groupId, sectionId, included, token = 'token') {
        return apiClient.patch(
            `${this.endpoint}/${groupId}/sections/`,
            { id: sectionId, included },
            token
        );
    }

    // Add a section to an employee group
    addSection(groupId, sectionId, token = 'token') {
        return apiClient.patch(
            `${this.endpoint}/${groupId}/sections/`,
            { id: sectionId },
            token
        );
    }

    // Remove a section from an employee group
    removeSection(groupId, sectionId, token = 'token') {
        return apiClient.delete(
            `${this.endpoint}/${groupId}/sections/`,
            { id: sectionId },
            token
        );
    }

    // Update all sections for an employee group
    updateSections(groupId, sections, token = 'token') {
        const data = sections.map(section => ({ id: section.id, included: section.included }));
        return apiClient.put(
            `${this.endpoint}/${groupId}/sections/`,
            data,
            token
        );
    }
}

export const storeService = new StoreService();
export const employeeService = new EmployeeService();
export const employeeGroupService = new EmployeeGroupService();
